import { useTranslation } from 'react-i18next';
import { VoucherFormModel, VoucherContextType, VoucherValue } from './Voucher.model';
import { useForm } from 'react-hook-form';
import { InputText } from '../../forms';
import { Button } from '../../navigation';
import { VoucherSuccessMessage } from './VoucherSuccessMessage';
import styles from './Voucher.module.css';
import { useContext, useEffect, useState } from 'react';
import { VoucherContext } from './Voucher';

export function VoucherForm() {
	const { handleClick, setLoading, value } = useContext<VoucherContextType>(VoucherContext);
	const [voucherInfo, setVoucherInfo] = useState<VoucherValue>(value ?? { status: false });
	const { t } = useTranslation(['voucher', 'common']);
	const {
		register,
		handleSubmit,
		formState: { errors },
		setError,
		reset
	} = useForm<VoucherFormModel>();

	useEffect(() => {
		voucherInfo.message && setError('voucherCode', { message: voucherInfo.message });
	}, [voucherInfo]);

	useEffect(() => {
		setVoucherInfo(value ?? { status: false });
	}, [value]);

	const submitVoucher = async (voucherCode: string, removeDiscount: boolean) => {
		try {
			setLoading(true);
			const response = await handleClick(voucherCode, removeDiscount);
			response && setVoucherInfo(response);
			setLoading(false);
		} catch (error) {
			console.error('Error submitting form:', error);
		}
	};

	const resetVoucher = async () => {
		setLoading(true);
		await handleClick('', true);
		setVoucherInfo({ status: false });
		reset();
		setLoading(false);
	};

	const handleFormSubmit = async (data: VoucherFormModel) => {
		if (voucherInfo.status) {
			await resetVoucher();
		} else {
			await submitVoucher(data.voucherCode, false);
		}
	};
	const handleButtonText = () => {
		if (voucherInfo.isPartner) {
			return t('DELETE_BUTTON_FOR_DUMBO');
		}
		return voucherInfo.status ? t('DELETE_BUTTON') : t('common:APPLY_TEXT');
	};

	return (
		<form onSubmit={handleSubmit(handleFormSubmit)}>
			<div className={styles.box_form}>
				{voucherInfo.status ? (
					<VoucherSuccessMessage {...voucherInfo} />
				) : (
					<InputText
						id="voucherCode"
						errorMessage={errors.voucherCode?.message}
						{...register('voucherCode', {
							required: t('common:INPUT_REQUIRED_ERROR'),
							maxLength: 50
						})}
						label={t('PLACEHOLDER')}
					/>
				)}
				<Button
					type={'submit'}
					variant="primary"
					buttonSize="small"
					className={styles.box_button}
					data-testid="voucher-button"
				>
					{handleButtonText()}
				</Button>
			</div>
		</form>
	);
}
VoucherForm.displayName = 'VoucherForm';
